import { red, orange, yellow, green } from '@mui/material/colors';

export function getColorFromAge(age: number | undefined | null) {
  if (!age) {
    return 'inherit';
  } else if (age < 3600) {
    return green[400];
  } else if (age < 14400) {
    return green[700];
  } else if (age < 28800) {
    return orange[600];
  } else {
    return red[500];
  }
}

// export function getColorFromReliability(val: number | undefined) {
//   if (!val) return red[500];
//   if (val == 100) {
//     return green[500];
//   } else if (val > 80) {
//     return yellow[500];
//   } else if (val > 70) {
//     return orange[500];
//   } else {
//     return red[500];
//   }
// }

export function getColorFromTicks(ticks: number) {
  if (isNaN(ticks)) {
    return '#B0BECF';
  } else if (ticks > 10) {
    return green[500];
  }
  const value = Math.round((1 - Math.min(ticks, 10) / 10) * 100);
  const hue = ((1 - value / 100) * 120).toString(10);
  return ['hsl(', hue, ',100%,60%)'].join('');
}
